export const SCHEDULE_MODAL_EVENTS = {
  OPEN: 'scheduleModalOpen',
  CLOSE: 'scheduleModalClose',
  STEP_CHANGE: 'scheduleModalStepChange',
  BOOK_TIME_IMMEDIATELY_AFTER_SCHEDULING_INTRO_CALL:
    'scheduleModalBookTimeImmediatelyAfterSchedulingIntroCall',
};
